import { render, staticRenderFns } from "./setInspector.vue?vue&type=template&id=0d9509b6&scoped=true&"
import script from "./setInspector.vue?vue&type=script&lang=js&"
export * from "./setInspector.vue?vue&type=script&lang=js&"
import style0 from "./setInspector.vue?vue&type=style&index=0&id=0d9509b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9509b6",
  null
  
)

export default component.exports